import React, { useEffect, useState } from "react";
import { ReactComponent as BedroomIcon } from "assets/icons/bedroom.svg";
import { ReactComponent as BathIcon } from "assets/icons/bath.svg";
import { ReactComponent as AreaIcon } from "assets/icons/area.svg";
import { ReactComponent as BookmarkIcon } from "assets/icons/bookmark.svg";
import { ReactComponent as QuestionIcon } from "assets/icons/question.svg";
import { ReactComponent as RemoveIcon } from "assets/icons/remove.svg";
import { ReactComponent as ArrowRight } from "assets/icons/arrow_long_right_btn.svg";
import PropertyCardImageSlider from "./SearchCard/components/PropertyCardImageSlider";
import SearchCard from "./SearchCard";
import { formatCurrency } from "utils/formatNumber";
import useBookmark from "hooks/useBookmark";
import { useOrganiseList } from "context/OrganiseListContext";
import useProperties from "hooks/useProperties";
import { useNavigate } from "react-router-dom";
import { usePropertyActions } from "hooks/usePropertyActions";
import ChooseAndCreateOrganiseList from "components/Dialog/ChooseAndCreateOrganiseList";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";

const MapPropertyPopupCard = ({ property }) => {
  const {
    isBookmarked,
    isDoubtProperty,
    isDiscardedProperty,
    handleAction,
    handleRemoveConfirm,
    removeWarningPopupOpen,
    setRemoveWarningPopupOpen,
    isBookmarkPropertyHasNote,
    chooseOrganiseList,
    setChooseOrganiseList,
    handleUpdateNote,
    handleAddBookmark,
  } = usePropertyActions(property);
  const navigate = useNavigate();

  return (
    <>
      <div className="w-[246px] h-[238px] bg-white rounded-[10px] overflow-hidden">
        <div className="w-full h-[121px] relative max-h-[121px] grid">
          <PropertyCardImageSlider property={property} isOnMapMini={true} />
        </div>
        <div className="px-[13px] pb-[11px]">
          <h1 className="text-black font-bold text-[24px] leading-[30.24px] mt-[6px]">
            {formatCurrency(property.sale_price, property?.sale_currency)}
          </h1>
          <div className="flex items-center space-x-[24px] mt-[6px] h-5">
            <div className="flex items-center space-x-2">
              <BedroomIcon className="stroke-primary text-primary" />
              <p className="text-[14px] font-normal text-[#6C727F] leading-[19.6px]">
                {property?.bedrooms || 0}
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <BathIcon />
              <p className="text-[14px] font-normal text-[#6C727F] leading-[19.6px]">
                {property?.bathrooms || 0}
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <AreaIcon />
              <p className="text-[14px] font-normal text-[#6C727F] leading-[19.6px]">
                {property?.total_area || 0} m²
              </p>
            </div>
          </div>
          <div className="flex items-center justify-between mt-[9px]">
            <div className="border border-[#F0F0F0] rounded-[11px] h-[35px] w-[145px] flex items-center justify-between px-[17px]">
              <BookmarkIcon
                onClick={() => handleAction("bookmark")}
                className={`${
                  isBookmarked
                    ? "text-[#7BCD11]"
                    : "hover:text-[#7BCD1133] text-white"
                } cursor-pointer  stroke-black w-[15px] h-[14px]  transition-all duration-300 ease-in-out`}
              />
              <hr className="w-[0.79px] h-[20.18px] bg-[#F0EFFB] ml-[18.22px] mr-[13px]" />
              <QuestionIcon
                onClick={() => handleAction("doubt")}
                className={`${
                  isDoubtProperty
                    ? "fill-[#FC9D47]"
                    : "fill-white hover:fill-[#FEEDDA]"
                } cursor-pointer w-[16px] h-[14px] hover:fill-[#FC9D47] transition-all duration-300 ease-in-out`}
              />
              <hr className="w-[0.79px] h-[20.18px] bg-[#F0EFFB] mr-[14.35px] ml-[16px]" />
              <RemoveIcon
                onClick={() => handleAction("discard")}
                className={`${
                  isDiscardedProperty ? "fill-[#FF6D59]" : "fill-white"
                }  cursor-pointer w-[14px] h-[12px] hover:fill-[#FF6D59] transition-all duration-300 ease-in-out`}
              />
            </div>
            <div
              onClick={() =>
                navigate(
                  `/property/${property?._id}?average_gross_yield=${property?.average_gross_yield}`
                )
              }
              className="bg-[#F6F8FE] cursor-pointer rounded-[11px] h-[36px] w-[62px] flex items-center justify-center"
            >
              <ArrowRight />
            </div>
          </div>
        </div>
      </div>
      <RemoveWarningDialog
        warningText={removeWarningPopupOpen}
        isOpen={removeWarningPopupOpen}
        isClose={() => setRemoveWarningPopupOpen(null)}
        onClick={handleRemoveConfirm}
        buttonText2="Annulla"
      />
      <ChooseAndCreateOrganiseList
        isOpen={chooseOrganiseList}
        onClose={() => setChooseOrganiseList(false)}
        onSaveClick={handleAddBookmark}
      />
    </>
  );
};

export default MapPropertyPopupCard;
